export const SET = 'Survey/SET';